import React, {FC, PropsWithChildren} from 'react';

import {getHasPushV2} from '../../../../../libs/shared/core/src/services/push/common/pushSelectors';
import {useCommonAppSelector} from '../../../../../libs/shared/core/src/store/useCommonAppSelector';
import {ChatPushContainer} from '../../chatPushContainer';
import {ChatPushV2Provider} from './chatPush';

export const ChatPushContextProvider: FC<PropsWithChildren> = ({children}) => {
  const isPushV2Enabled = useCommonAppSelector(getHasPushV2);
  if (isPushV2Enabled) {
    return <ChatPushV2Provider>{children}</ChatPushV2Provider>;
  }

  return <ChatPushContainer>{children}</ChatPushContainer>;
};
